var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawchecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70595 55H52.2537M29.9798 55V16.1111M29.9798 16.1111C33.0552 16.1111 35.5483 13.6238 35.5483 10.5556M29.9798 16.1111C26.9046 16.1111 24.4114 13.6238 24.4114 10.5556M35.5483 10.5556C35.5483 7.48731 33.0552 5 29.9798 5C26.9046 5 24.4114 7.48731 24.4114 10.5556M35.5483 10.5556H52.2537M24.4114 10.5556H7.70595M13.2744 43.8889C17.4857 43.8889 20.9691 41.5511 21.5439 37.6425C21.5803 37.3947 21.5986 37.2708 21.5843 36.9961C21.5745 36.8064 21.51 36.46 21.4511 36.2792C21.3657 36.0178 21.2621 35.8342 21.055 35.4667L13.2744 21.6667L5.49379 35.4667C5.30182 35.8072 5.20585 35.9775 5.11706 36.2733C5.06243 36.4553 4.9992 36.8919 5.00001 37.0817C5.00129 37.3906 5.02 37.4719 5.05747 37.635C5.76734 40.7222 9.17623 43.8889 13.2744 43.8889ZM46.6852 43.8889C50.8966 43.8889 54.38 41.5511 54.9547 37.6425C54.9911 37.3947 55.0095 37.2708 54.995 36.9961C54.9853 36.8064 54.921 36.46 54.862 36.2792C54.7765 36.0178 54.6729 35.8342 54.4658 35.4667L46.6852 21.6667L38.9047 35.4667C38.7128 35.8072 38.6168 35.9775 38.5279 36.2733C38.4734 36.4553 38.4102 36.8919 38.4107 37.0817C38.4121 37.3906 38.4308 37.4719 38.4684 37.635C39.1783 40.7222 42.5871 43.8889 46.6852 43.8889Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawchecklist);
export default __webpack_public_path__ + "static/media/lawchecklist.ab41b72b02cf88d5a71b52ab0f70f8e5.svg";
export { ForwardRef as ReactComponent };